<template>
  <div class="page">
    <Header></Header>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="body" :style="bannerStyle">
        <div :style="bannerHeightStyle">
        </div>
        <div class="filter">
          <van-dropdown-menu>
            <van-dropdown-item :title="target" :toggle="targetOpen" @change="toggleTarget">
              <div class="filter-tags filter-city">
                <span v-for="item in targetList" :key="item.dict_value" :class="item.selected?'tag active':'tag'"
                      :style="filterTagStyle" @click="targetSelect(item)">{{ item.dict_name }}</span>
              </div>
            </van-dropdown-item>
            <van-dropdown-item :title="city" :toggle="cityOpen" @change="toggleCity">
              <div class="filter-tags filter-city">
                <span v-for="item in cityList" :key="item.id" :class="item.selected?'tag active':'tag'"
                      :style="filterTagStyle" @click="citySelect(item)">{{ item.city_name }}</span>
              </div>
            </van-dropdown-item>
            <van-dropdown-item :title="seq" :toggle="seqOpen" @change="toggleSeq">
              <div class="filter-tags filter-seq">
                <span v-for="item in seqList" :key="item.sequence" :class="item.selected?'tag active':'tag'"
                      :style="filterTagStyle" @click="seqSelect(item)">{{ item.seqtext }}</span>
              </div>
            </van-dropdown-item>
          </van-dropdown-menu>
        </div>
        <div class="list">
          <div class="title">
            职位列表<span class="title-sub">每位学生只能投递一个职位</span>
          </div>
          <van-list
              :finished="finished"
              :finished-text="!loading && (!list || list.length==0)?'':'没有更多了'"
              @load="onLoad"
          >
            <div class="box" v-for="item in list" :key="item.code" @click="gotoDetail(item)">
              <div class="box-title">{{ item.name }}</div>
              <div class="tags">
                <van-tag v-if="item.workPlaceShow" color="#e4ecfa" text-color="#206CFE">{{ item.workPlaceShow }}
                </van-tag>
                <!--                    <van-tag class="ellipsis" v-if="item.tags" color="#f5eee9" text-color="#FF8E25">{{item.tags}}</van-tag>-->
              </div>
              <!--                  <div class="box-content">-->
              <!--                    2019-2022届毕业生-->
              <!--                  </div>-->
            </div>
          </van-list>
          <NoData v-if="!loading && (!list || list.length==0)" message="暂无校招职位"></NoData>
          <SafeBottom></SafeBottom>
        </div>
      </div>
    </van-pull-refresh>
    <Footer></Footer>
  </div>
</template>

<script>
import Vue from "vue";
import {Cell, Dialog, DropdownItem, DropdownMenu, Icon, Image as VanImage, List, PullRefresh, Tag, Toast} from 'vant';
import 'vant/lib/index.css';
import Request from "../utils/Request";
import Urls from "../utils/Urls";
import wx from 'weixin-js-sdk';
import Utils from "../utils/Utils";
import Header from "./Header1";
import Footer from "./Footer";
import NoData from "./NoData";
import SafeBottom from "./SafeBottom";

Vue.use(VanImage);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Cell);
Vue.use(Dialog);
Vue.use(Icon);
Vue.use(Tag);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
export default {
  name: "PositionList",
  components: {
    SafeBottom,
    NoData,
    Header,
    Footer
  },
  data() {
    return {
      winWidth: window.innerWidth,
      bannerStyle: "background-image: url('https://www2.autoimg.cn/oadfs/g33/M09/07/4A/ChxpVmqg93mADEkkABnpAItLfes190.jpg');",
      bannerHeightStyle: "height: 103px;",
      app: '',
      pageCount: 1,
      currentPage: 0,
      pageSize: 10,
      refreshing: false,
      loading: false,
      finished: false,
      search: "",
      list: [],

      filterTagStyle: "width:" + ((window.innerWidth - 40 - 16) / 3) + "px",
      city: '所在城市',
      seq: '职能类别',
      target: '类型',
      cityOpen: false,
      seqOpen: false,
      targetOpen: false,
      cityList: [],
      seqList: [],
      targetList: [],
    };
  },
  mounted: function () {
    this.app = Utils.getApp();
    this.getBannerHeight();
    this._resizeHandler = () => {
      setTimeout(() => {
        this.getBannerHeight();
      }, 10)
    };
    window.addEventListener('resize', this._resizeHandler);
    // if(this.$route.query.seq) {
    //   this.seqList = [{sequence: this.$route.query.seq, seqtext: '', selected: true}];
    // }
    if (this.$route.query.targetId) {
      this.targetList = [{dict_value: this.$route.query.targetId, dict_name: '', selected: true}];
    }
    this.getPositionOptions();
    //this.getPositionList();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._resizeHandler);
  },
  methods: {
    getBannerHeight() {
      let width = window.innerWidth;
      let height = width / (375.0 / 103);
      this.bannerHeightStyle = "height: " + height + "px;";
    },
    getPositionOptions() {
      let that = this;
      Request.request(Urls.getSchoolRecruitOptions, {}).then(res => {
        if (res) {
          let cityList = [{city_name: '全部', id: '', selected: true}];
          if (res.cityList) {
            res.cityList.forEach(n => {
              n.selected = false;
              cityList.push(n);
            })
          }
          that.cityList = cityList;
          let seqList = [{seqtext: '全部', sequence: '', selected: true}];
          if (res.seqList) {
            res.seqList.forEach(n => {
              n.selected = false;
              seqList.push(n);
            })
          }
          that.seqList = seqList;


          let targetList = [{dict_name: '不限', dict_value: '', selected: true}];
          if (res.targetList) {
            res.targetList.forEach(n => {
              if (n.dict_value == "1003" || n.dict_value == "1004") {
                n.selected = false;
                if (n.dict_value == this.$route.query.targetId) {
                  n.selected = true;
                  that.target = n.dict_name;
                  targetList[0].selected = false;
                }
                targetList.push(n);
              }
            })
          }
          that.targetList = targetList;

        }
      });
    },
    getPositionList() {
      let that = this;
      let city = [];
      this.cityList.forEach(n => {
        if (n.id && n.selected) {
          city.push(n.id);
        }
      });
      let seq = [];
      this.seqList.forEach(n => {
        if (n.sequence && n.selected) {
          seq.push(n.sequence);
        }
      });
      let targetList = [];
      this.targetList.forEach(n => {
        if (n.dict_value && n.selected) {
          targetList.push(n.dict_value);
        }
      });
      that.loading = true;
      Toast.loading({
        duration: 0,
        forbidClick: true,
      });
      Request.request(Urls.getSchoolRecruitPositionList, {
        schoolRecruit: 1,
        currentPage: that.currentPage,
        targetId: targetList && targetList.length ? targetList.join(",") : "", // 实习 全职
        pageSize: that.pageSize,
        search: that.search,
        work_place: city && city.length ? city.join(",") : "",
        func_cat_id: seq && seq.length ? seq.join(",") : ""
      }).then(res => {
        that.loading = false;
        that.refreshing = false;
        Toast.clear();
        if (res) {
          let list = res.list || [];
          that.list = that.currentPage == 1 ? list : that.list.concat(list);
          if (res.count > that.pageSize) {
            if (res.count % that.pageSize == 0) {
              this.pageCount = res.count / that.pageSize;
            } else {
              this.pageCount = res.count / that.pageSize + 1;
            }
          }
          if (that.currentPage >= that.pageCount) {
            that.finished = true;
          }
        }
      });
    },
    onLoad() {
      if (this.finished || this.refreshing || this.loading) {
        return false;
      }
      this.currentPage += 1;
      console.log(this.currentPage)
      this.getPositionList();
    },
    onRefresh() {
      this.finished = false;
      this.currentPage = 1;
      this.getPositionList();
    },
    gotoDetail(item) {
      if (this.app == 'WeiXinMini') {
        Toast.loading({
          duration: 500,
          forbidClick: true,
        });
        wx.miniProgram.navigateTo({
          url: '/pages/m/child?url=position&param=' + encodeURIComponent('id=' + item.id),
          complete: () => {
            Toast.clear();
          }
        });
      } else {
        this.$router.push({
          path: '/position', query: {
            id: item.id,
          }
        });
      }
    },
    toggleCity(val) {
      this.cityOpen = val;
    },
    toggleTarget(val) {
      this.targetOpen = val;
    },
    toggleSeq(val) {
      this.seqOpen = val;
    },
    targetSelect(item) {
      if (item.dict_value) {
        this.targetList[0].selected = false;
        item.selected = !item.selected;
        let find = this.targetList.find(n => {
          return n.selected;
        });
        if (!find) {
          this.targetList[0].selected = true;
        }
      } else {
        this.targetList.forEach(n => {
          n.selected = false
        });
        item.selected = true;
      }
      let target = [];
      this.targetList.forEach(n => {
        if (n.id && n.selected) {
          target.push(n.dict_name);
        }
      });
      this.target = target && target.length > 0 ? target.join("、") : '类型';
      this.currentPage = 1;
      this.getPositionList();
    },
    citySelect(item) {
      if (item.id) {
        this.cityList[0].selected = false;
        item.selected = !item.selected;
        let find = this.cityList.find(n => {
          return n.selected;
        });
        if (!find) {
          this.cityList[0].selected = true;
        }
      } else {
        this.cityList.forEach(n => {
          n.selected = false
        });
        item.selected = true;
      }
      let city = [];
      this.cityList.forEach(n => {
        if (n.id && n.selected) {
          city.push(n.city_name);
        }
      });
      this.city = city && city.length > 0 ? city.join("、") : '所在城市';
      this.currentPage = 1;
      this.getPositionList();
    },
    seqSelect(item) {
      if (item.sequence) {
        this.seqList[0].selected = false;
        item.selected = !item.selected;
        let find = this.seqList.find(n => {
          return n.selected;
        });
        if (!find) {
          this.seqList[0].selected = true;
        }
      } else {
        this.seqList.forEach(n => {
          n.selected = false
        });
        item.selected = true;
      }
      let seq = [];
      this.seqList.forEach(n => {
        if (n.sequence && n.selected) {
          seq.push(n.seqtext);
        }
      });
      this.seq = seq && seq.length > 0 ? seq.join("、") : '职能类别';
      this.currentPage = 1;
      this.getPositionList();
    }

  }
}
</script>

<style scoped>
.page {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.body {
  /*flex: 1;*/
  background-repeat: no-repeat;
  background-size: contain;
  /*display: flex;*/
  /*flex-direction: column;*/
  /*overflow: hidden;*/
}

.filter {
  height: 44px;
  background-color: #FFFFFF;

  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #111E36;
  letter-spacing: 0;
  font-weight: 400;
}

.filter .van-dropdown-menu >>> .van-dropdown-menu__bar {
  box-shadow: none;
  padding: 0 20px;
}

.filter .van-dropdown-menu >>> .van-dropdown-menu__bar .van-dropdown-menu__item + .van-dropdown-menu__item {
  margin-left: 12px;
}

.filter .van-dropdown-menu >>> .van-dropdown-menu__title--active {
  color: #0055FF !important;
}

.filter-tags {
  padding: 20px 12px 12px 20px;
  flex-direction: row;
}

.filter-tags .tag {
  height: 40px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  margin-bottom: 8px;
  background: #F8F9FC;
  border-radius: 4px;

  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #111E36;
  text-align: center;
  line-height: 12px;
  font-weight: 400;
}

.filter-tags .active {
  background: rgba(0, 85, 255, 0.08) !important;
  font-family: PingFangSC-Medium !important;
  color: #0055FF !important;
  font-weight: 500 !important;
}

.list {
  background-color: #F5F7FA;
  /*border-top-right-radius: 35px;*/
}

.van-pull-refresh {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background-color: #F5F7FA;
}

.title {
  padding: 16px 20px;
  height: 22px;
  font-family: PingFangSC-Medium;
  font-size: 20px;
  color: #20253F;
  line-height: 22px;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.title-sub {
  margin-left: 8px;
  height: 14px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #9499B0;
  letter-spacing: 0;
  line-height: 14px;
  font-weight: 400;
}

.box {
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 0px;
  margin-bottom: 10px;
  padding: 12px 16px 5px;
  background-color: #FFFFFF;
  border-radius: 6px;
}

.box-title {
  height: 22px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #20253F;
  line-height: 22px;
  font-weight: 500;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tags {
  margin-top: 11px;
  margin-bottom: 11px;
  display: flex;
}

.van-tag {
  display: block;
  border-radius: 2px;
  padding: 1px 3px;
  white-space: nowrap;
}

.van-tag + .van-tag {
  margin-left: 11px;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
}

.box-content {
  height: 18px;
  font-family: PingFangSC-Regular;
  font-size: 13px;
  color: #20253F;
  font-weight: 400;
}

</style>